import { createRoot } from "react-dom/client"
import Highcharts from "highcharts"
import App from "./App"
import { store } from "./lib/store"
import { BrowserRouter } from "react-router"
import { Provider } from "react-redux"
import Authenticated from "./pages/_authenticated"
import AppThemeProvider from "./theme/AppThemeProvider"
import "./less/App.less"

Highcharts.setOptions({ accessibility: { enabled: false } })

const root = createRoot(document.getElementById("root"))

root.render(
  <Provider store={store}>
    <AppThemeProvider>
      <Authenticated>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Authenticated>
    </AppThemeProvider>
  </Provider>,
)
